export const INITIAL_TIME = 14;
export const TRANSITION_TIME = 2;
